import styled from '@emotion/styled';

export const Container = styled.div`
    position:relative;
    padding:10px;
`

export const H1 = styled.h1`
    color: pink;
    text-transform:uppercase;
`
export const H3 = styled.h3`
    color: pink;
    text-transform:uppercase;
`
export const AccountPanelTitle = styled.h6`
    text-transform:uppercase;
`
export const LiquidationCard = styled.div`
    display:inline-block;
    width:50%;
`
export const LiquidationResult = styled.div`
    display:inline-block;
    width:50%;
    padding-left:20px;
    padding-right:20px;
`
export const LiquidationContent = styled.div`
    display:flex;
`
export const LiquidationInformationCard = styled.div`
    background:white;
`
export const LiquidationDataView = styled.div`
    
`